import { translate } from "app/filters/i18nFilter";
import { ChipDownContainer } from "@similarweb/ui-components";
import { allTrackers } from "app/services/track/track";
import useCompetitiveFilter from "../../hooks/useCompetitiveFilter";
import type { ICategory } from "app/common/services/categoryService.types";
import { getCategoriesOptions, getCategoryNameForTracking } from "../../helpers/getCategories";
import { StyledChipWrap } from "../CompetitiveFilter/styles";
import { StyledCategoryItem } from "./styles";
import type { CompetitiveLandscapeCategory } from "../../types/dto";

export const CompetitiveCategoryFilter = ({ categories }: { categories: CompetitiveLandscapeCategory[] }) => {
    const { onSelectCategory, selectedCategory } = useCompetitiveFilter();

    const handleSelectCategory = (category: ICategory) => {
        allTrackers.dispatchTrackEvent("Drop Down", "click", `Table/Category/${getCategoryNameForTracking(category)}`);
        onSelectCategory(category && category.id);
    };

    const handleClearCategory = () => {
        handleSelectCategory(null);
    };

    return (
        <StyledChipWrap>
            <ChipDownContainer
                width={340}
                onClick={handleSelectCategory}
                selectedText={selectedCategory ?? ""}
                onCloseItem={handleClearCategory}
                buttonText={translate("common.category.all")}
                searchPlaceHolder={translate("home.dashboards.wizard.filters.searchCategory")}
                tooltipDisabled={true}
                hasSearch={true}
                noResultsMessage={translate("dropdown.no.results")}
            >
                {getCategoriesOptions(categories).map((category) => (
                    <StyledCategoryItem
                        {...category}
                        key={category.id}
                    />
                ))}
            </ChipDownContainer>
        </StyledChipWrap>
    );
};
